import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

export const OMNIBOX_ANALYTICS_ACTIONS = {
  OPENED_OMNIBOX: {
    module: ANALYTICS_MODULE.OMNIBOX,
    action: 'opened_omnibox',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_RESULT: {
    module: ANALYTICS_MODULE.OMNIBOX,
    action: 'clicked_omnibox_result',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SUBMITTED_QUERY: {
    module: ANALYTICS_MODULE.OMNIBOX,
    action: 'submitted_omnibox_query',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_QUICK_ACTION: {
    module: ANALYTICS_MODULE.OMNIBOX,
    action: 'clicked_omnibox_quick_action',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_RESULT_AI_CHAT: {
    module: ANALYTICS_MODULE.OMNIBOX,
    action: 'clicked_omnibox_result_ai_chat',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_ADVANCED_SEARCH: {
    module: ANALYTICS_MODULE.OMNIBOX,
    action: 'clicked_omnibox_advanced_search',
    actionCategory: ACTION_CATEGORY.READ,
  },
  ADDED_FILTER: {
    module: ANALYTICS_MODULE.OMNIBOX,
    action: 'added_omnibox_filter',
    actionCategory: ACTION_CATEGORY.READ,
  },
  REMOVED_FILTER: {
    module: ANALYTICS_MODULE.OMNIBOX,
    action: 'removed_omnibox_filter',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLEARED_ALL_FILTERS: {
    module: ANALYTICS_MODULE.OMNIBOX,
    action: 'cleared_all_omnibox_filters',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLOSED_OMNIBOX: {
    module: ANALYTICS_MODULE.OMNIBOX,
    action: 'closed_omnibox',
    actionCategory: ACTION_CATEGORY.READ,
  },
  DISPLAYED_RESULTS: {
    module: ANALYTICS_MODULE.OMNIBOX,
    action: 'displayed_omnibox_results',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SUBMITTED_OMNIBOX_REACTION_FEEDBACK: {
    module: ANALYTICS_MODULE.OMNIBOX,
    action: 'submitted_omnibox_reaction_feedback',
    actionCategory: ACTION_CATEGORY.READ,
  },
};
